import {CSSProperties, FC} from 'react';


export interface IIconUserNissanProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconUserNissan: FC<IIconUserNissanProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M14.597 12.516c1.407-1.15 1.957-3.1 1.372-4.857-.586-1.757-2.18-2.936-3.969-2.936-1.79 0-3.383 1.179-3.969 2.936-.586 1.757-.035 3.707 1.372 4.857-2.396.998-4.07 3.284-4.354 5.95a.726.726 0 0 0 .623.807.711.711 0 0 0 .777-.648c.318-2.943 2.714-5.168 5.565-5.168 2.85 0 5.247 2.225 5.565 5.168.04.37.341.65.7.648h.077a.721.721 0 0 0 .616-.8c-.286-2.674-1.969-4.965-4.375-5.957ZM12 12c-1.546 0-2.8-1.303-2.8-2.91 0-1.606 1.254-2.908 2.8-2.908 1.546 0 2.8 1.302 2.8 2.909 0 .771-.295 1.511-.82 2.057A2.748 2.748 0 0 1 12 12Z" clipRule="evenodd" />
        </svg>
    );
};
